<template>
  <div>
    <v-card :class="{ card: true, 'not-ready': props.disabled }" @click="onCardClick">
      <v-menu v-if="props.menuItems.length > 0">
        <template #activator="{ props: aProps }">
          <v-btn v-bind="aProps" icon="mdi-dots-vertical" variant="tonal" size="x-small" class="float-right"> </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="item in menuItems" :key="item.name" @click="onMenuItemClick(item)">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="title">
        {{ props.title }}
      </div>
      <v-tooltip right :text="props.tagTooltip" :disabled="!props.tagTooltip">
        <template #activator="{ props: aProps }">
          {{ aProps.tagTooltip }}
          <v-chip v-bind="aProps" prepend-icon="mdi-circle-medium" size="small" :color="props.tagColor" rounded="lg">
            {{ props.tagText }}
          </v-chip>
        </template>
      </v-tooltip>
      <div v-for="descText in props.desc" :key="descText" class="subtitle">{{ descText }}</div>
    </v-card>
  </div>
</template>

<script setup>
const props = defineProps({
  title: { required: true, type: String },
  disabled: { required: true, type: Boolean },
  tagColor: { required: false, type: String, default: "success" },
  tagText: { required: true, type: String },
  tagTooltip: { required: false, type: String, default: undefined },
  desc: { required: true, type: Array },
  onClick: { required: true, type: Function },
  allowEdit: { required: false, type: Boolean, default: false },
  menuItems: { required: false, type: Array, default: () => [] },
  onEdit: {
    required: false,
    type: Function,
    default() {
      return;
    },
  },
});

const onCardClick = () => {
  if (props.allowEdit) {
    return props.onEdit(props);
  } else if (props.disabled) {
    return;
  } else {
    return props.onClick(props);
  }
};

const onMenuItemClick = (item) => {
  item.onClick();
};
</script>

<style lang="scss" scoped>
@import "@/styles/components/_kanban-card.scss";
</style>
